import variacoesApi from "@/app/services/variacoesApi";

export default {
  namespaced: true,
  state: {
    variacao: {
      descricao: "",
    },
    variacao_valor: {
      variacao_id: null,
      descricao: "",
    },
    variacoes: [],
    valores: [],
    pagination: {},
    total_de_registros: 1,
    search: "",
  },

  mutations: {
    listar(state, variacoes) {
      state.variacoes = variacoes;
    },

    ABRIR(state, variacao) {
      state.variacao = variacao;
    },

    ADICIONAR(state, variacao) {
      state.variacoes.unshift(variacao);
    },

    ATUALIZAR(state, variacao) {
      let index = state.variacoes.findIndex(variacao_ => variacao_.id == variacao.id);
      if (index > -1) {
        state.variacoes.splice(index, 1, variacao);
      }
    },

    EXCLUIR(state, id) {
      let index = state.variacoes.findIndex((variacao) => variacao.id == id);
      if (index > -1) {
        state.variacoes.splice(index, 1);
      }
    },

    ADICIONAR_VALOR(state, variacao_valor) {
      state.variacao.valores.push(variacao_valor);
    },

    EDITAR_VALOR(state, variacao_valor) {
      state.variacao_valor = {...variacao_valor};
    },

    ATUALIZAR_VALOR(state, variacao_valor) {
      let index = state.variacao.valores.findIndex(variacao_valor_ => variacao_valor_.id == variacao_valor.id);
      if (index > -1) {
        state.variacao.valores.splice(index, 1, variacao_valor);
      }
    },

    EXCLUIR_VALOR(state, id) {
      let index = state.variacao.valores.findIndex((valor) => valor.id == id);
      if (index > -1) {
        state.variacao.valores.splice(index, 1);
      }
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },

    ZERAR(state) {
      state.variacao = {
        id: null,
        descricao: "",
      };
    },

    ZERAR_VALOR(state) {
      state.variacao_valor = {
        variacao_id: null,
        descricao: "",
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await variacoesApi.listar(parametros);
      commit("listar", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let variacao = await variacoesApi.abrir(id);
      commit("ABRIR", variacao);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit, dispatch }, variacao) {
      let nova = await variacoesApi.salvar(variacao);
      commit("ADICIONAR", nova);
      dispatch("listar");
    },

    async atualizar({ commit }, variacao) {
      const atualizada = await variacoesApi.atualizar(variacao);
      commit("ATUALIZAR", atualizada);
    },

    async excluir({ commit }, id) {
      await variacoesApi.excluir(id);
      commit("EXCLUIR", id);
    },

    async abrirValor({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      let variacao_valor = await variacoesApi.abrirValor(id);
      commit('ABRIR_VALOR', variacao_valor);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvarValor({ commit }, variacao_valor) {
      let variacao_valor_nova = await variacoesApi.salvarValor(variacao_valor);
      commit('ADICIONAR_VALOR', variacao_valor_nova);
    },

    async atualizarValor({ commit }, variacao_valor) {
      let variacao_valor_atualizada = await variacoesApi.atualizarValor(variacao_valor);
      commit('ATUALIZAR_VALOR', variacao_valor_atualizada);
    },

    async excluirValor({ commit }, id) {
      await variacoesApi.excluirValor(id);
      commit('EXCLUIR_VALOR', id);
    }
  }
};
